import { Button, CityState, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovementCard extends Layout {
    buttonClose: Button;
    citystateDestination: CityState;
    citystateOrigin: CityState;
    collapsedStatus: Image;
    horizontalspacerCollapsed: HorizontalSpacer;
    horizontalspacerHeader: HorizontalSpacer;
    horizontalspacerLine: HorizontalSpacer;
    imageDestinationDetention: Image;
    imageDetentionActive: Image;
    imageDetentionClosed: Image;
    imageDetentionReview: Image;
    imageEmpty: Image;
    imageOriginDetention: Image;
    imageStatus: Image;
    labelArrived: Label;
    labelCollapsedDestinationCity: Label;
    labelCollapsedDestinationState: Label;
    labelCollapsedOriginCity: Label;
    labelCollapsedOriginState: Label;
    labelCollapsedTo: Label;
    labelDestAddress: Label;
    labelDestCaption: Label;
    labelDestLate: Label;
    labelDestName: Label;
    labelDestinationCity: Label;
    labelDestinationState: Label;
    labelDistCaption: Label;
    labelDistToNextStop: Label;
    labelDistance: Label;
    labelEtaNextStop: Label;
    labelHeaderTrackingLate: Label;
    labelMoveDistance: Label;
    labelNextStopLateStatus: Label;
    labelOrderCaption: Label;
    labelOrderId: Label;
    labelOriginAddress: Label;
    labelOriginCaption: Label;
    labelOriginCity: Label;
    labelOriginLate: Label;
    labelOriginLocationName: Label;
    labelOriginState: Label;
    labelStopsPickDrop: Label;
    labelTo: Label;
    labelTrackingLateBadge: Label;
    labelTrackingLateMinutes: Label;
    labelWeight: Label;
    panelActualDelivery: Panel;
    panelActualOrigin: Panel;
    panelBottomRow: Panel;
    panelCollapsed: Panel;
    panelCollapsedHeadingText: Panel;
    panelCommodity: Panel;
    panelDash: Panel;
    panelDestTimes: Panel;
    panelDestination: Panel;
    panelDestinationDetention: Panel;
    panelDist: Panel;
    panelEmpty: Panel;
    panelEmptyDash: Panel;
    panelEtaToNext: Panel;
    panelExpandedButtons: Panel;
    panelHeadingText: Panel;
    panelMoveHeader: Panel;
    panelMovement: Panel;
    panelMovementInfo: Panel;
    panelNextStopLateStatus: Panel;
    panelOrder: Panel;
    panelOrigin: Panel;
    panelOriginDetention: Panel;
    panelOriginTimes: Panel;
    panelOverlapSpacer: Panel;
    panelScheduledDelivery: Panel;
    panelScheduledPickup: Panel;
    panelTopInfo: Panel;
    panelTopRow: Panel;
    textboxCommodity: Textbox;
    textboxCustomer: Textbox;
    textboxDestinationArrival: Textbox;
    textboxDestinationDeparture: Textbox;
    textboxDolly1: Textbox;
    textboxDolly2: Textbox;
    textboxEtaToNextStop: Textbox;
    textboxOriginArrival: Textbox;
    textboxOriginDeparture: Textbox;
    textboxPieces: Textbox;
    textboxScheduledDelivery: Textbox;
    textboxScheduledPickup: Textbox;
    textboxTrailer2: Textbox;
    textboxTrailer3: Textbox;
    textboxTrailer: Textbox;
}
